import {
  ChangeDetectorRef,
  Directive,
  ElementRef,
  EventEmitter,
  Injectable,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { ControlValueAccessor } from '@angular/forms';
import { TemplateUuids } from 'src/app/utils/shared-utils';

@Directive()
@Injectable()
export abstract class ToggleableInputDirective implements ControlValueAccessor {
  @ViewChild('input', { static: true })
  _inputElement: ElementRef;

  private _checked = false;
  @Input()
  get checked(): boolean {
    return this._checked;
  }
  set checked(value: boolean) {
    this._checked = value;
    this._inputElement.nativeElement.checked = value;
    this._changeDetectorRef.markForCheck();
  }

  private _disabled = false;
  templateUuids = new TemplateUuids();

  @Input()
  get disabled() {
    return this._disabled;
  }
  set disabled(value: any) {
    this._disabled = !!value;
  }

  private _indeterminate = false;
  @Input()
  get indeterminate(): boolean {
    return this._indeterminate;
  }
  set indeterminate(value: boolean) {
    this._indeterminate = value ? true : false;
    this._inputElement.nativeElement.indeterminate = this._indeterminate;
    this._changeDetectorRef.markForCheck();
  }

  private _value: any = null;
  @Input()
  get value(): any {
    return this._value;
  }
  set value(value: any) {
    if (this.value !== value) {
      this._value = value;
    }
  }

  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() change = new EventEmitter();

  constructor(private _changeDetectorRef: ChangeDetectorRef) {}

  _onChangeEvent(event: Event) {
    event.stopPropagation();

    this.checked = this._inputElement.nativeElement.checked;
    this.change.emit(this.checked);
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onChangeCallback = (_: any) => {};

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onTouchedCallback = () => {};

  registerOnChange(fn: (value: any) => any): void {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: () => any): void {
    this.onTouchedCallback = fn;
  }

  setDisabledState(isDisabled: boolean) {
    this.disabled = isDisabled;
    this._changeDetectorRef.markForCheck();
  }

  writeValue(val: any) {
    if (val !== this.value) {
      this.value = val;
    }
  }
}
